import { FC } from 'react';
import { Link } from 'react-router-dom';
import { RouteNames } from '../../router';
import { InfoBtnProps } from './InfoBtn.types';

export const InfoBtn: FC<InfoBtnProps> = ({ title, className }) => (
    <Link className={className} to={RouteNames.INFO}>
        {title || 'Информация о компании'}
    </Link>
);
